import React, { useEffect, useState } from "react";
import {
  createModulesDTO,
  createModulesTestDTO,
} from "../helpers/dto_submit_create-modules";
import { generateDataFromSpecificsAmount } from "../helpers/generate_amount_input_module";
import ModuleInput from "./ModuleInput";
import TermSelection from "./TermSelection";
import OptionInput from "./OptionInput";
import Checkbox from "./Checkbox";
import useForm from "../hooks/useForm";
import validate from "../validation/index";

const DEFAULT_AMOUNT = 5;

const ENDPOINT = "/sis/course_modules";

const init = {
  modules: [],
  isOverride: false,
  type_create:false,//check
  term: {
    term_code: "",
    open_year: "",
  },
};
function CreateModule(props) {
  const [inputData, setInputData] = useState([]);
  const [amountSelect, setAmountSelect] = useState(DEFAULT_AMOUNT);
  const [initialState, setInitialState] = useState(() => init);
  const [sis_id, setSisId] = useState("");
  const [type_create, setTypeCreate] = useState();
  const [terms, setTerms] = useState([
    // { term_code: "10", open_year: "2010", term_name: "reactjs" },
    // { term_code: "11", open_year: "2011", term_name: "nodejs" },
    // { term_code: "12", open_year: "2012", term_name: "docker" },
    // { term_code: "13", open_year: "2013", term_name: "nestjs" },
  ]);

  useEffect(() => {
    const amountModule = generateDataFromSpecificsAmount(amountSelect);

    setInputData([...amountModule]);
  }, [amountSelect]);

  useEffect(() => {
    const fetchTermsData = async () => {
      const res = await fetch(`/sis/terms`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (res.ok) {
        const data = await res.json();
        setTerms(data);
      }
    };

    fetchTermsData();
  }, []);

  const handleCreateModule = async () => {
    if (type_create) {
      if (sis_id == null || sis_id == "") {
        alert('Course list is empty, Please, fill out the couse list first!')
        return;
      }
      // alert(JSON.stringify('course list: '+sis_id))
    }else{
      if (values.term.open_year == "" ||values.term.term_code == "") {
        alert('There is no Term was selected, Please, select a term first!')
        return;
      }
      // alert(JSON.stringify('term: '+JSON.stringify(values.term)))
    }
    const isConfirmed = window.confirm("Are you sure to make new job?");
    
    if (isConfirmed) {
      try {
        if (!type_create) {
          console.log("creating modules for a Term");
          const dataSubmit = createModulesDTO(values);
          console.log("DATASUBMIT :", dataSubmit);
          const res = await fetch(`${ENDPOINT}`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataSubmit),
          });
          if (res.ok) {
            await res.json();
            window.scrollTo({ top: 0, behavior: "smooth" });
          } else {
            alert("Fetch logs error! ");
          }
        } else {
          let tempSisID = sis_id;
          tempSisID = tempSisID.replace(/\s/g,'');
          tempSisID = tempSisID.replace(/\n/g,'');
          let courseList = tempSisID.split(',');
          console.log("creating modules for a Course list");
          const dataSubmit = createModulesTestDTO(values,courseList);
          console.log("VALUE TO TEST: ", values);
          console.log("DATA TO TEST: ", dataSubmit);
          const res = await fetch(`${ENDPOINT}/${courseList[0]}`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataSubmit),
          });
          if (res.ok) {
            await res.json();
            window.scrollTo({ top: 0, behavior: "smooth" });
          } else {
            alert("Fetch logs error! ");
          }
        }
      } catch (error) {
        alert("Fetch logs error! " + error.message);
      }
    }
  };

  const { values, handleOnChange, handleOnSubmit } = useForm(
    handleCreateModule,
    validate,
    initialState
  );

  useEffect(() => {
    if (inputData.length !== 0) {
      // const initialModule = convertArrayToObject(inputData);
      // const _term = {
      //   modules: inputData,
      //   isOverride: values.isOverride,
      //   term: values.term,
      // };

      setInitialState((prev) => ({
        ...prev,
        modules: inputData,
      }));
    }
  }, [inputData]);

  const handleOnChangeSisID = (event) => {
    setSisId(event.target.value);
  };

  const handleOnChangeTypeCreate = () => {
    setTypeCreate(!type_create);
  };

  const handleSelectedModuleAmount = (amount) => {
    setAmountSelect(Number(amount));
  };

  return (
    <div className="create-module__wrapper">
      <div className="create-module__title">Automatically create module</div>
      <div className="create-module__formControl create-module__formControl--checkbox">
      <div style={{backgroundColor:"white", marginTop:"10px"}}>
        <label style={{ marginTop:"15px", marginRight:"10px" }} className="create-module__formControl--label">Create modules for a term</label>
        <label
          htmlFor="create-type--checkbox"
          className="create-module__label--checkbox"
          >
          <input
            id="create-type--checkbox"
            name={"switchTypeCreate"}
            onChange={handleOnChangeTypeCreate}
            className="create-module__input--checkbox"
            type="checkbox"
            checked={type_create}
          />
          <span className="create-module__slider--checkbox create-module__round--checkbox" />
        </label>
        <label style={{ marginTop:"15px", marginLeft:"10px" }} className="create-module__formControl--label">Create modules for a course list </label>
      </div>

    </div>

    <div style={{marginLeft:"25px", width:"150px"}} className="create-module__options--amount-module">
            <OptionInput
              type="number"
              label="Enter number of modules"
              onChange={handleSelectedModuleAmount}
              name="module_amount"
            />
    </div>

      <form
        style={{ maxWidth: "100%", width: "100%" }}
        onSubmit={handleOnSubmit}
      >
        {!type_create ? 
        <div className="create-module__options" style={{marginTop:"20px"}}>
          <div className="create-module__options--term">
              <TermSelection
                label="Select Term"
                name="term"
                value={(values && values.term) || {}}
                data={terms}
                onChange={handleOnChange}
              />
            </div>
            <div></div>
          </div> 
        :
        <div className="create-module__options" style={{height:"200px"}}>
          <div style={{ width: "100%", marginRight: "25px"}} className="create-module__options--sisID-course">
            <label style={{ color: "green", fontWeight: "bold" }}>Input format: each course_Id separated by ','</label>
            <textarea 
            style={{ height: "150px", width: "100%", resize: "none"}}
            placeholder={"List of course"}
            value={sis_id}
            onChange={handleOnChangeSisID}>
            </textarea>
          </div>
          <div></div>
        </div>
        }  

        <div className="create-module__form">
          {inputData.map((ele) => (
            <ModuleInput
              key={ele.id}
              data={ele}
              values={values.modules}
              handleOnChange={(e) => handleOnChange(e, "modules")}
            />
          ))}

          <Checkbox
            isOverride={values.isOverride || false}
            handleOnChecked={handleOnChange}
            name="isOverride"
          />

          <div className="create-module__button">
            <button
              className="create-module__button--save"
              disabled={terms.length === 0 ? true : false}
              type="submit"
            >
              Start Create Modules
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

CreateModule.propTypes = {};

export default CreateModule;
